<template>
    <v-container>
        <v-card>
            <v-tabs>
                <v-tab href="#config">{{text.mailconfig}}</v-tab>
                <v-tab href="#training" v-if="ecAdmin">{{text.administrator.traning}}</v-tab>
                <v-tab href="#event" @click="getEcEvent"><v-badge color="pink" dot :value="activeEvent">{{text.ecEvent}}</v-badge></v-tab>
                <v-tab href="#report" @click="getEcEvent"><v-badge color="pink" dot :value="activeEvent">{{text.reportView}}</v-badge></v-tab>
                <v-tab href="#chat" @click="getChat" v-if="activeEvent && allowChat>0">{{text.chatTitle}}</v-tab>
                <v-tab href="#messege" v-if="false">{{text.sendMessege}}</v-tab>

                <v-tab-item value="config">
                    <div v-if="appvalProxy">
                        <v-alert dense type="info">{{appvalMessege}}</v-alert>
                        {{text.messege.apprvalConf}}
                        <v-btn @click="appval(true)" :disabled="disAppvalBtn">{{text.yes}}</v-btn><v-btn @click="appval(false)" :disabled="disAppvalBtn">{{text.no}}</v-btn>
                    </div>
                    <v-subheader>{{text.contactAdress}}</v-subheader>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Adress</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="adressDetail in contactAdress" :key="adressDetail._count">
                                <th>{{adressDetail._count}}</th>
                                <th>{{adressDetail.value}}</th>
                                <th>
                                    <div v-show="adressDetail._action">
                                        <v-tooltip top>
                                            <template v-slot:activator="{on}">
                                                <v-icon v-on="on" @click="removeAdress(adressDetail._count)">mdi-email-fast</v-icon>
                                            </template>
                                            {{text.remove}}
                                        </v-tooltip>
                                    </div>
                                    <div v-show="!adressDetail._action">
                                        <v-tooltip top>
                                            <template v-slot:activator="{on}">
                                                <v-icon v-on="on" @click="addAdress(adressDetail._count)">mdi-email-fast-outline</v-icon>
                                            </template>
                                            {{text.add}}
                                        </v-tooltip>
                                    </div>
                                </th>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-tab-item>
                <v-tab-item value="training" v-if="ecAdmin">
                    <startEventComponent  @parentCall="parentCallback"/>
                </v-tab-item>
                <v-tab-item value="event">
                    <div v-show="activeEvent">
                        {{text.messege.activeReport}}<br>
                        <div v-for="reportData in reportList" :key="reportData.reportId">
                            {{reportData.overview}}
                            <a :href="reportData.url" target="_blank">{{text.report}}</a>{{text.messege.reportSetter}}
                        </div>
                    </div>
                </v-tab-item>
                <v-tab-item value="report">
                    <eventListComponent ref="eventListRef" @parentCall="parentCallback" :ecAdmin="ecAdmin"/>
                </v-tab-item>
                <v-tab-item value="chat" v-if="allowChat>0">
                    <chatComponent ref="chatRef" @parentCall="parentCallback" :activeEventId="activeEventId"/>
                </v-tab-item>
                <v-tab-item value="messege" v-if="false">
                    <sendMessegeComponent @parentCall="parentCallback" v-if="ecAdmin"/>
                </v-tab-item>
            </v-tabs>
        </v-card>
        <v-dialog persistent v-model="digAddAdress" max-width="500">
            <v-card>
                <v-card-title>{{text.adressTite}}</v-card-title>
                <v-card-text>
                    <v-select :items="adressType" @change="selectAdressType" v-model="setAdressType" :label="text.messege.selectAdressType"></v-select>
                    <v-divider></v-divider>
                    <div v-show="addMail"><!--メールアドレス-->
                        <v-text-field autocomplete="off" v-model="addMailAdress" type="email" :label="text.mailAdress"></v-text-field>
                        <v-btn @click="exeAddMailAdress" :disabled="disAddMailBtn">{{text.add}}</v-btn><br>
                        <span v-show="addedMail">{{text.messege.regMail}}</span>
                    </div>
                    <div v-show="addLine"><!--LINE-->
                        {{text.messege.regLine.a}}<br>
                        {{text.messege.regLine.b}}<br>
                        <img src="@/assets/OGIHARA_LINE.png"><br>
                        <span v-html="text.messege.regLine.c"></span><br>
                        {{text.messege.regLine.d}}<br>
                        <v-btn @click="getLineConfCode" :disabled="disGetLineBtn">{{text.messege.regLine.e}}</v-btn><br>
                        <span>{{text.messege.regLine.f}}:</span>
                        <span class="text-h4">{{lineConfCode}}</span>
                        <br>
                        {{text.messege.regLine.g}}<br>
                        {{text.messege.regLine.h}}<br>
                        {{lineAdduserMessege}}
                    </div>
                    <div v-show="addedLine"><!--LINE登録済み-->
                        {{text.messege.regLine.j}}<br>
                    </div>
                    <div v-show="addProxy"><!--代理-->
                        {{text.messege.regProxy.a}}<br>
                        {{text.messege.regProxy.b}}<br>
                        {{text.messege.regProxy.c}}<br>
                        <v-text-field autocomplete="off" v-model="addProxyUserId" :label="text.pCode" :error-messages="addProxyError"></v-text-field>
                        <v-btn @click="exeaddProxyUserId" :disabled="disAddProxyBtn">{{text.add}}</v-btn><br>
                        <span v-show="addedProxy">{{text.messege.regProxy.d}}</span>
                    </div>
                    <div v-show="onlyProxy">
                        {{text.messege.regProxy.c}}<br>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="closedigAddAdress">{{text.close}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="digRemoveAdress" max-width="500">
            <v-card>
                <v-card-text>
                    {{removeValue}}<br>
                    {{text.messege.removeConf}}
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="removeAdressExec">{{text.yes}}</v-btn>
                    <v-btn @click="digRemoveAdress = false">{{text.no}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import exceljs from "exceljs";
    import fileSaver from "file-saver";
    import {apiRequest} from "../lib/api";
    import {ecAddressType} from "../lib/api/api_response_type";
    import * as comm from '../common';
    import * as type from '../types';
    import eventListComponent from './eventList.vue';
    import chatComponent from './chat-form.vue';
    import startEventComponent from './startEvent.vue';
    import sendMessegeComponent from './messegeSend.vue';

    interface vueEventComp extends Vue{
        getEcEvent:()=>void;
    }
    interface vueChatComp extends Vue{
        getMesseges:()=>Promise<void>;
    }
    export default Vue.extend({
        components:{
            eventListComponent,
            chatComponent,
            startEventComponent,
            sendMessegeComponent,
        },
        data: () => ({
            text : text.Text,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
            userData:{} as type.userData,
            reportList:[] as Array<{reportId:string,url:string,overview:string}>,
            chatCompoElm:null as null|vueChatComp,
            ecAdmin:false,
            activeEvent:false,
            activeEventId:"",
            appvalProxy:false,
            appvalMessege:"",
            digAddAdress:false,
            addMailAdress:"",
            addMail:false,
            addLine:false,
            addedLine:false,
            addedMail:false,
            disAddMailBtn:false,
            disGetLineBtn:false,
            disExcelBtn:false,
            digRemoveAdress:false,
            disAddProxyBtn:false,
            addProxy:false,
            addedProxy:false,
            addProxyError:"",
            onlyProxy:false,
            disAppvalBtn:false,
            addProxyUserId:"",
            lineConfCode:"",
            lineAdduserMessege:"",
            lineActive:false,
            proxyActive:false,
            removeRow:null as number|null,
            removeValue:"",
            defs:{} as {[key:string]:string},
            adressType:[] as Array<{value:any,text:string}>,
            setAdressType:"",
            viewItems:[] as Array<{defname:string,value:string}>,
            contactAdress:[] as Array<{type:ecAddressType|null,value:string|null,code:string|null,_action:boolean,_count:number,_adress:string}>,
            apprvalProxyConfCode:"",
            ecEventList:[] as Array<{eventId:string,_regDate:Date,regDate:string,_mode:number,mode:string,overview:string,_show:boolean}>,
            viewEventDetail:"",
            selectEventId:"",
            sEventList:true,
            sEventDetail:false,
            reportData:{
                reportHeders:[] as Array<type.Vuetify_data_table_heders>,
                reportColumnFilter:[] as Array<null|Array<string>>,
                reportData:[] as Array<Array<string>>,
            },
            allowChat:0,
        }),
        mounted(){
            this.api = this.$store.state.apiSaver;
            this.chatCompoElm = this.$refs.chatRef as vueChatComp;
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            parentCallback(order:string){
                switch(order){
                    case "pageShow":
                        this.userData = this.$store.state.user;
                        this.adressType = [
                            {"text":this.text.adressType.mail,"value":"mail"},
                            {"text":this.text.adressType.line,"value":"line"},
                            {"text":this.text.adressType.proxy,"value":"proxy"},
                        ];
                        this.getEvent();
                        this.getUserInfo();
                        if(this.userData.ecAdmin){
                            this.ecAdmin = true;
                        }else{
                            this.ecAdmin = false;
                        }
                    break;
                    case "reset":
                        this.reset();
                    break;
                    default:
                        this.$emit("parentCall",order);
                        break;
                }
            },
            getEcEvent(){
                const eventDetail = this.$refs.eventListRef as vueEventComp;
                if(eventDetail){
                    eventDetail.getEcEvent();
                }else{
                    setTimeout(this.getEcEvent,10);
                }
            },
            async getEvent(){
                let eventData:null|Array<type.ecEvent> = null;
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const result = await this.api.apiRequest.request.getEvents()
                    //comm.LoadingOverlay(this,false);
                    if(result.statusCode === 200 && result.data){
                        eventData = result.data;
                        for(const [k,v] of Object.entries(eventData)){
                            let reportData = null as {reportId:string,url:string,overview:string}|null;
                            const ecReport = await this.api.apiRequest.request.getEcReportsList(v.eventId);
                            //await apiCall.getReport(v.eventId).then(apiResponse=>{
                            comm.LoadingOverlay(this,false);
                            if(ecReport.statusCode === 200 && ecReport.data){
                                const apidata = ecReport.data;
                                const eventList = apidata.report.filter(v=>{
                                    if(v.userId === this.userData.userId){
                                        return true;
                                    }else{
                                        return false;
                                    }
                                });
                                if(v.eventMode === 2){
                                    this.activeEvent = true;
                                    this.activeEventId = v.eventId;
                                }
                                if(eventList.length === 1){
                                    let ovv = "";
                                    if(v.alertInfo.type === "earthquake" && v.alertInfo.earthquake){
                                        ovv = comm.formatDate(new Date(v.eventDate),"mm/dd HH:MM");
                                        ovv += "/"+this.text.earthquake + "/";
                                        ovv += this.text.quakeLeve + v.alertInfo.earthquake.maxIntText + "/";
                                        ovv += comm.formatDate(new Date(v.eventDate),"mm/dd HH:MM");
                                    }
                                    if(v.alertInfo.type === "training" && v.alertInfo.training){
                                        ovv = v.alertInfo.training.messege;
                                    }
                                    if(v.alertInfo.type === "manual" && v.alertInfo.manual){
                                        ovv = v.alertInfo.manual.subject;
                                    }
                                    reportData = {
                                        "overview" : ovv,
                                        "reportId" :eventList[0].reportID,
                                        "url" : `./?c=eqc&q=${encodeURIComponent(eventList[0].reportID)}`,
                                    }
                                }
                            }else if(ecReport.statusCode === 401){
                                comm.invalidSession(this);
                            }else{
                                comm.ApiErrorMessege(this,comm.unknowError,true);
                            }
                            if(reportData){
                                this.reportList.push(reportData);
                            }
                        }
                    }else if(result.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            async getUserInfo(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const apiResponse = await this.api.apiRequest.request.my.userInfo();
                    comm.LoadingOverlay(this,false);
                    if(apiResponse.statusCode === 200){
                        const userInfo = apiResponse.data;
                        this.lineActive = false;
                        this.proxyActive = false;
                        if(userInfo.allowChatUse){
                            this.allowChat = userInfo.allowChatUse;
                        }else{
                            this.allowChat = 0;
                        }
                        if(userInfo.ecAdress){
                            this.contactAdress = userInfo.ecAdress.map((v,i)=>{
                                if(v && v.type === "line"){this.lineActive=true}
                                if(v && v.type === "proxy"){this.proxyActive=true;}
                                return {
                                    "type":v?v.type:null,
                                    "value":v?
                                        v.type==="mail"?`${v.adress}${v.conf?"":"("+this.text.notConf+")"}`:
                                        v.type==="line"?v.conf?`${this.text.lineUser}:${v.adress}`:`${this.text.lineUser}:${this.text.notConf}`:
                                        v.type==="proxy"?`${this.text.proxyAdress}(${v.adress})${v.conf?"":"("+this.text.notConf+")"}`:
                                        "":
                                        "",
                                    "_adress":v?v.adress?v.adress:"":"",
                                    "_action":v?true:false,
                                    "_count":i+1,
                                } as {type:"mail"|"line"|null,value:string|null,code:string|null,_action:boolean,_count:number,_adress:string}
                            });
                        }
                        if(userInfo.approvalRequest && userInfo.approvalRequest.length > 0){
                            if(userInfo.approvalRequest[0].type === "proxy"){
                                this.appvalMessege = comm.strReplacePercentObject(this.text.messege.approvalProxy,{
                                    "USERNAME":userInfo.approvalRequest[0].userName,
                                    "PCODE":userInfo.approvalRequest[0].userId
                                });
                                this.apprvalProxyConfCode = userInfo.approvalRequest[0].confCode;
                                this.appvalProxy = true;
                            }
                        }
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
            removeAdress(row:number){
                this.removeRow = row-1;
                if(!this.contactAdress[this.removeRow]){
                    return false;
                }
                const adressV = this.contactAdress[this.removeRow].value;
                this.removeValue = adressV?adressV:"";
                this.digRemoveAdress = true;
            },
            async removeAdressExec(){
                if(typeof this.removeRow !== "number"){
                    return false;
                }
                const removeAdressType = this.contactAdress[this.removeRow].type;
                if(!removeAdressType){return false;}
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const result = await this.api.apiRequest.request.my.removeAddress(this.removeRow+1);
                    this.digRemoveAdress = false;
                    if(result.statusCode === 200 && result.data){
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        this.getUserInfo();
                    }else if(result.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            addAdress(row:number){
                this.digAddAdress = true;
            },
            async getLineConfCode(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    const result = await this.api.apiRequest.request.my.addAddress({"type":"line","adress":""})
                    if(result.statusCode === 200 && result.data){
                        this.lineConfCode = typeof result.data === "string"?result.data:"";
                        setTimeout(this.checkLineUserAdded,5000);
                    }else if(result.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                }
            },
            async checkLineUserAdded(){
                if(this.lineConfCode){
                    if(this.api && this.api.connection && this.api.apiRequest){
                        const verify = await this.api.apiRequest.request.addressConf(this.lineConfCode,{"lineActivate":true});
                        if(verify.data.activated && verify.data.name){
                            const regLineMes = this.text.messege.regLine.i;
                            const nameReg = new RegExp("%name%","g");
                            this.lineAdduserMessege = regLineMes.replace(nameReg,verify.data.name);
                            this.getUserInfo();
                        }else{
                            if(this.digAddAdress){
                                setTimeout(this.checkLineUserAdded,1000);
                            }
                        }
                    }
                }
            },
            async exeAddMailAdress(){
                this.disAddMailBtn = true;
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.my.addAddress({
                        "type":"mail",
                        "adress":this.addMailAdress,
                    });
                    if(apiResponse.statusCode !== 200){
                        comm.ApiErrorMessege(this,comm.unknowError);
                        return;
                    }
                    this.getUserInfo();
                    this.addedMail = true;
                }
            },
            closedigAddAdress(){
                this.addMail = false;
                this.addLine = false;
                this.addedLine = false;
                this.addProxy = false;
                this.addedProxy = false;
                this.onlyProxy = false;
                this.setAdressType = "";
                this.addMailAdress = "";
                this.addProxyUserId = "";
                this.digAddAdress = false;
                this.disAddMailBtn = false;
                this.addedMail = false;
                this.addProxyError = "";
            },
            selectAdressType(){
                this.addMail = false;
                this.addLine = false;
                this.addedLine = false;
                this.addProxy = false;
                this.addedProxy = false;
                this.onlyProxy = false;
                if(this.proxyActive){
                    this.onlyProxy = true;
                }else{
                    if(this.setAdressType === "mail"){
                        this.addMail = true;
                    }
                    if(this.setAdressType === "line"){
                        if(this.lineActive){
                            this.addedLine = true;
                        }else{
                            this.addLine = true;
                        }
                    }
                    if(this.setAdressType === "proxy"){
                        if(this.contactAdress.find(v=>{
                            if(v && v.type){return true}
                        })){
                            this.onlyProxy = true;
                        }else{
                            this.addProxy = true;
                        }
                    }
                }
            },
            async exeaddProxyUserId(){
                this.addProxyError = "";
                if(this.addProxyUserId.length<1){ 
                    return false;
                }
                if(this.addProxyUserId === this.userData.userId){
                    this.addProxyError = this.text.messege.selfProxyError;
                    return;
                }
                this.disAddProxyBtn = true;
                comm.LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.my.addAddress({
                        "type":"proxy",
                        "adress":this.addProxyUserId,
                    });
                    if(apiResponse.statusCode !== 200){
                        comm.ApiErrorMessege(this,comm.unknowError);
                        return;
                    }
                    this.getUserInfo();
                    this.addedMail = true;
                }
            },
            async appval(appr:boolean){
                this.disAppvalBtn = true;
                if(this.apprvalProxyConfCode && this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const apiResponse = await this.api.apiRequest.request.addressConf(this.apprvalProxyConfCode,{"proxyApprval":appr});
                    if(apiResponse.statusCode === 200){
                        this.appvalProxy = false;
                        comm.SuccessMessege(this,this.text.messege.dbSccess);
                        comm.LoadingOverlay(this,false);
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError,true);
                    }
                    this.getUserInfo();
                    this.addedMail = true;
                }
                this.disAppvalBtn = false;
            },
            getChat(){
                this.chatCompoElm = this.$refs.chatRef as vueChatComp;
                if(this.chatCompoElm){
                    this.chatCompoElm.getMesseges();
                }else{
                    setTimeout(this.getChat,100);
                }
            },
            exportExcel(){
                this.disExcelBtn = true;
                this.exportExcelSave();
            },
            async exportExcelSave(){
                const workBook = new exceljs.Workbook();
                const sheet = workBook.addWorksheet();
                comm.exceljsUtils.setRow(sheet,{row:1,column:1},this.reportData.reportHeders.map(v=>v.text));
                let row = 2;
                for(const item of this.reportData.reportData){
                    comm.exceljsUtils.setRow(sheet,{"row":row,"column":1},item);
                    row++;
                }
                const _wbBuffer = await workBook.xlsx.writeBuffer();
                fileSaver.saveAs(new Blob([_wbBuffer]),"report.xlsx");
                this.disExcelBtn = false;
            },
        }
    });
</script>